module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/82b7f01c0e0f7966c9a2bb4c1bcc6298.png";